import globalConfig from '../utiles/globalConfig';
export default {
  computed: {
    customExeCenterStyle() {
      const from = globalConfig.getHrefParam('from');
      const gameId = globalConfig.getHrefParam('gameId');
      if (
        (from === 'pnsClient' || from === 'exeClient') &&
        [386].includes(+gameId)
      ) {
        return 'custom-exe-center';
      }
      return '';
    },
    showExeSwitchAccount() {
      const from = globalConfig.getHrefParam('from');
      const gameId = globalConfig.getHrefParam('gameId');
      const isExeInIframe = globalConfig.getHrefParam('exeInIframe') == 1;
      return (
        (from === 'pnsClient' || from === 'exeClient') &&
        [386].includes(+gameId) &&
        isExeInIframe
      );
    }
  },
  methods: {
    openExeSwitchAccount() {
      window.parent.postMessage(
        {
          method: 'exePageShowLogin'
        },
        window.location.origin
      );
    }
  }
};
